module.exports = __webpack_public_path__ + "img/icon_fengxiang.dcaec38a.png";